import { IconNew, ModBox } from '@jfs/ui-new'
import React from 'react'

const Undo = React.memo(({ onPress, item }: any) => {
  const handleUndo = () => {
    onPress && onPress(item)
  }
  return (
    <ModBox flexDirection={'row'} alignItems={'flex-end'}>
      <ModBox
        width={32}
        borderWidth={1}
        borderColor={'GRAY_BORDER'}
        borderRadius={4}
        alignItems={'center'}
        justifyContent={'center'}
        onPress={handleUndo}
        underlayColor={'DISABLED_GREY'}>
        <IconNew id={'ICON_REFRESH_CIRCLE'} color={'BLACK_21'} />
      </ModBox>
    </ModBox>
  )
})

export { Undo }
